/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import L from "../Lang";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ScanInventory extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            scan: {},
            scanHistory: [],
            searchBox: {}
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/account/list', 'accounts');
    }

    change = (e, resetPO) => {
        let info = { ...this.state.info };
        if (resetPO)
            info.purchaseOrderID = null;
        this.setState({ info: info });
    }

    onAccountChange = async (v) => {
        if (!Auth.hasRole('manager'))
            return;
        if (!v)
            return;
        try {
            let j = await qreq.getAsync('/api/purchase-order/list/out/' + v);
            if (j.list)
                this.setState({ purchaseOrders: j.list });
            else
                this.alert(j.errorMessage);
            this.change(null, true);
        }
        catch (e) {
            this.unkownErrorCallback(e);
            this.change(null, true);
        }
    }

    scan = async (v) => {
        this.setState({ scannedItem: null, errorMessage: null });
        if (!v || v.length < 2)
            return;
        try {
            const info = {
                accountID: Number(this.state.info.accountID),
                lotNumber: v,
                in: this.props.in,
                out: this.props.out,
                purchaseOrderID: this.state.info.purchaseOrderID
            };
            if (this.state.box)
                info.inventoryBoxID = this.state.box.id;
            let j = await qreq.postAsync('/api/inventory/scan', info);
            if (j.item) {
                let scanHistory = [...this.state.scanHistory];
                j.item.scanDate = new Date();
                scanHistory.unshift(j.item);
                this.setState({ scan: {}, scannedItem: j.item, scanHistory: scanHistory });
            }
            else {
                this.setState({ errorMessage: j.errorMessage });
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    checkScan = async () => {
        if (this.state.scan?.barcode !== this.currentScan) {
            this.currentScan = this.state.scan?.barcode;
            await this.scan(this.state.scan.barcode);
        }
    }

    searchBox = async (v) => {
        if (!v) {
            this.setState({ searchBoxList: [] });
            return;
        }
        const info = { name: v };
        try {
            let j = await qreq.postAsync('/api/inventory/box/search', info);
            if (j.list) {
                this.setState({ searchBoxList: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submitBox = async (e) => {
        e?.preventDefault();
        const info = { ...this.state.searchBox };
        try {
            let j = await qreq.postAsync('/api/inventory/box/create-select', info);
            if (j.item) {
                this.setState({ box: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    selectBox = (i) => {
        this.setState({ box: i });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Scan In</L></h1>

                {/*<Card title="Put in Box?" isCollapse collapse onHide={() => this.setState({ box: null, searchBox: {} })}>
                    {!this.state.box ? <form onSubmit={this.submitBox}>
                        <div className="d-flex">
                            <div className="flex-fill">
                                <FormInput model={this.state.searchBox} name="name" labelAsPlaceholder required label="Enter box name here..." onChange={this.searchBox} />
                            </div>
                            <div>
                                <button type="submit" className="btn btn-primary">
                                    <L>Create Box</L>
                                </button>
                            </div>
                        </div>
                        {this.state.searchBoxList?.length > 0 && <ul className="list-group">
                            {this.state.searchBoxList.map((i, idx) => <li key={idx} className="list-group-item" role="button" onClick={() => this.selectBox(i)}>
                                {i.name}
                            </li>)}
                        </ul>}
                    </form> : <div>
                        <h3>{this.state.box.name} <Icon icon="faClose" onClick={() => this.setState({ box: null })} /></h3>
                    </div>}
                </Card>*/}

                <Card title={this.props.in ? 'Scan In' : 'Scan Out'}>
                    {(this.props.out || !Auth.hasRole('manager'))
                        && <><FormInput model={this.state.info}
                            label="Account"
                            name="accountID"
                            type="select"
                            options={this.state.accounts ?? []}
                            onChange={this.onAccountChange}
                            autoSelect
                        />
                            {Auth.hasRole('manager') && <FormInput model={this.state.info}
                                label="Purchase Order"
                                name="purchaseOrderID"
                                type="select"
                                options={this.state.purchaseOrders ?? []}
                                onChange={this.change}
                            />}
                        </>}
                    <FormInput
                        model={this.state.scan}
                        label="Scan Barcode Below"
                        name="barcode"
                        placeholder="Activate this input before scanning..."
                        inputClassName="form-control-lg"
                        autoFocus
                        disabled={this.props.out
                            && (!this.state.info.accountID || !this.state.info.purchaseOrderID)}
                    />
                </Card>
                <Tick onTick={this.checkScan} />
                {this.state.errorMessage && <Alert type="danger" message={this.state.errorMessage} />}
                {this.state.scanHistory?.length > 0 && <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th><L>Manufacturer</L></th>
                            <th><L>Product</L></th>
                            <th><L>Size</L></th>
                            <th><L>Catalog Code</L></th>
                            <th><L>Lot Number</L></th>
                            <th><L>Expiration Date</L></th>
                            <th><L>Scan Date</L></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.scanHistory.map((item, idx) => <tr key={idx}>
                            <td>{item.manufacturerName}</td>
                            <td>{item.productName}</td>
                            <td>{item.productSize}</td>
                            <td>{item.catalogCode}</td>
                            <td>{item.lotNumber}</td>
                            <td>{item.expirationDate}</td>
                            <td>{Globals.toMDYHMLocalDateStringOrDiff(item.scanDate)}</td>
                        </tr>)}
                    </tbody>
                </table>}

            </div>
        );
    }
}

export default withParamsAndNavigate(ScanInventory);